import React, { useState, useEffect } from "react";

const ChangeFlagDialog = ({
  open,
  onClose,
  onSubmit,
  dialogName = "Dialog",

  comboLabel = "Select an Option",
  comboBoxData = [],
  initComboBoxValue = "",
  onComboBoxChange,

  textFieldLabel = "Enter Value",
  initTextFieldValue = "",

  divLabel = "Enter Value",
  initDivValue = "",

  showComboBox = true,
  showTextField = true,
  showDetailsDiv = true,
}) => {
  const [comboBoxValue, setComboBoxValue] = useState(initComboBoxValue);
  const [textFieldValue, setTextFieldValue] = useState(initTextFieldValue);
  const [divContent, setDivContent] = useState(initDivValue);

  useEffect(() => {
    setComboBoxValue(initComboBoxValue);
    setTextFieldValue(initTextFieldValue);
    setDivContent(initDivValue);
  }, [initComboBoxValue, initTextFieldValue, initDivValue]);

  const handleComboBoxChange = (event) => {
    const selectedValue = event.target.value;
    setComboBoxValue(selectedValue);

    if (onComboBoxChange) {
      const updatedDivContent = onComboBoxChange(selectedValue);
      if (updatedDivContent !== undefined) {
        setDivContent(updatedDivContent);
      }
    }
  };

  const handleTextFieldChange = (event) => {
    setTextFieldValue(event.target.value);
  };

  const handleClose = () => {
    onClose();
  }

  const handleSubmit = () => {
    const formData = {
      comboBoxValue,
      textFieldValue,
      divContent,
    };
    onSubmit(formData);
  };

  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.dialog}>
        <h2 style={styles.title}>{dialogName}</h2>
        <div style={styles.content}>
          {showComboBox && (
            <div style={styles.field}>
              <label htmlFor="comboBox" style={styles.label}>
                {comboLabel}
              </label>
              <select
                id="comboBox"
                style={styles.select}
                value={comboBoxValue}
                onChange={handleComboBoxChange}>
                <option value="" disabled>
                  Choose an option
                </option>
                {comboBoxData.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          )}

          {showTextField && (
            <div style={styles.field}>
              <label htmlFor="textField" style={styles.label}>
                {textFieldLabel}
              </label>
              <input
                id="textField"
                type="text"
                style={styles.input}
                value={textFieldValue}
                onChange={handleTextFieldChange}
              />
            </div>
          )}

          {showDetailsDiv && (
            <div style={styles.field}>
              <label htmlFor="textField" style={styles.label}>
                {divLabel}
              </label>
              <div style={{
                  ...styles.detailsDiv,
                  display: "block",
                  backgroundColor: divContent.startsWith("#") ? divContent : "#f9f9f9"}}>
                {divContent.startsWith("#") ? "" : divContent}
              </div>
            </div>
          )}
        </div>
        <div style={styles.actions}>
          <button style={styles.button} onClick={handleClose}>
            Cancel
          </button>
          <button style={styles.button} onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  dialog: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    width: "400px",
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  title: {
    margin: 0,
    marginBottom: "15px",
    fontSize: "18px",
    textAlign: "center",
  },
  content: {
    marginBottom: "20px",
  },
  field: {
    marginBottom: "15px",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "bold",
  },
  select: {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  input: {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  detailsDiv: {
    height: "30px",
    backgroundColor: "#f9f9f9",
    padding: "5px",
    fontSize: "14px",
    color: "#333",
    border: "1px solid #ddd",
    borderRadius: "4px",
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
  },
  button: {
    padding: "10px 20px",
    fontSize: "14px",
    cursor: "pointer",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#0069d9",
    color: "#fff",
    transition: "background-color 0.3s",
  },
};

export default ChangeFlagDialog;
